import { css } from '@emotion/react';
import { resolveColor } from './shared.js';

var solidVariant = function solidVariant(props) {
  return /*#__PURE__*/css("&,&:focus{color:white;background:", resolveColor('main', props), ";}&:hover,&:hover:focus{background:", resolveColor('hover', props), ";}&:active,&:active:focus{background:", resolveColor('active', props), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:solidVariant;"));
};

export { solidVariant };
